import {
  TOGGLE_DRAWER,
} from './mutation-types';

export default {
  [TOGGLE_DRAWER](state) {
    state.drawer = !state.drawer;
  },
};
